<template>
  <div class="logo-container">
    <el-image class="container" v-show="isCollapse" :src="require('@/assets/img/icon_ar.png')" fit="contain" />
    <span v-show="!isCollapse" style="font-size: 18px;color: white;    text-shadow: rgb(153, 153, 153) 0px 1px 0px, rgb(136, 136, 136) 0px 2px 0px, rgb(119, 119, 119) 0px 3px 0px, rgb(102, 102, 102) 0px 4px 0px, rgb(85, 85, 85) 0px 5px 0px, rgb(68, 68, 68) 0px 6px 0px, rgb(51, 51, 51) 0px 7px 0px, rgb(0, 17, 53) 0px 8px 7px;letter-spacing: 0px;">{{appName}}</span>
  </div>
</template>

<script>
export default {
	name: 'SidebarLogo',
	props: {
		isCollapse: {
			type: Boolean
		}
	},
	data() {
		return {
			appName: '发货助手'
		}
	}
}
</script>

<style lang="scss" scoped>
.logo-container {
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #334053;
	.container {
		width: 64px;
		height: 64px;
	}
}
</style>
